import api from './api';

// 문서 관리 API 함수들
const documentsApi = {
  // 문서 그룹 관련 API
  createGroup: async (groupData) => {
    const response = await api.post('/documents/groups', groupData);
    return response.data;
  },

  listGroups: async () => {
    const response = await api.get('/documents/groups');
    return response.data;
  },

  getGroup: async (groupId) => {
    const response = await api.get(`/documents/groups/${groupId}`);
    return response.data;
  },

  updateGroup: async (groupId, groupData) => {
    const response = await api.put(`/documents/groups/${groupId}`, groupData);
    return response.data;
  },

  deleteGroup: async (groupId) => {
    const response = await api.delete(`/documents/groups/${groupId}`);
    return response.data;
  },

  listGroupDocuments: async (groupId, params = {}) => {
    const response = await api.get(`/documents/groups/${groupId}/documents`, { params });
    return response.data;
  },

  // 문서 관련 API
  uploadDocument: async (formData) => {
    const response = await api.post('/documents/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },
  
  // 문서 정보 가져오기
  getDocument: async (documentId) => {
    const response = await api.get(`/documents/${documentId}`);
    return response.data;
  },
  
  // 문서 목록 가져오기
  listDocuments: async (params = {}) => {
    const response = await api.get('/documents', { params });
    return response.data;
  },
  
  // 문서 삭제
  deleteDocument: async (documentId) => {
    const response = await api.delete(`/documents/${documentId}`);
    return response.data;
  },

  // 문서 일괄 삭제
  bulkDeleteDocuments: async (documentIds) => {
    const response = await api.post('/documents/bulk-delete', {
      document_ids: documentIds
    });
    return response.data;
  },

  // 문서 그룹 변경
  updateDocumentGroup: async (documentId, groupId) => {
    const response = await api.put(`/documents/${documentId}/group`, null, {
      params: { group_id: groupId }
    });
    return response.data;
  }
};

export default documentsApi; 